import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';

import LocationSearchInputBlock from './LocationSearchInputBlock';
import GeolocationButton from './presentionalComponents/GeolocationButton';

import { searchDeliveriesForGeoLocation } from '../../reduck/listingPageLocationSearchSetup.reduck';
import { getTranslation } from '../../translations/translations';

import { getActiveListingPage } from '../../reduck/selectors';

const Label = styled.div`
  @media ${({ theme }) => theme.breakpoints.mobile} {
    align-self: flex-start;
    margin-bottom: 10px;
  }
`;

const OrLabel = styled.div`
  @media ${({ theme }) => theme.breakpoints.mobile} {
    margin: 10px 0;
  }
`;

const GeolocationButtonWrapper = styled.div`
  @media ${({ theme }) => theme.breakpoints.mobile} {
    width: 100%;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;

  ${({ name }) =>
    name !== 'above product listing' &&
    css`
      justify-content: center;
      flex-direction: column;

      ${Label} {
        align-self: flex-start;
        margin-bottom: 10px;
      }

      ${OrLabel} {
        margin: 10px 0;
      }

      ${GeolocationButtonWrapper} {
        width: 100%;
      }

      @media ${({ theme }) => theme.breakpoints.desktop} {
        ${Label} {
          margin-left: 2px;
        }

        ${GeolocationButtonWrapper} {
          .dc-button {
            padding: 13px 10px;
          }
        }
      }
    `}

  @media ${({ theme }) => theme.breakpoints.mobile} {
    justify-content: center;
    flex-direction: column;
  }

  ${({ name }) =>
    name === 'above product listing' &&
    css`
      @media ${({ theme }) => theme.breakpoints.tablet} {
        justify-content: flex-start;
        flex-direction: row;

        ${Label} {
          margin-right: 10px;
          min-width: 90px;
        }

        .dc-location-search-input-block {
          max-width: 320px;
          min-width: 185px;
        }

        ${OrLabel} {
          margin: 0 10px;
        }
      }

      @media ${({ theme }) => theme.breakpoints.desktop} {
        justify-content: flex-start;
        flex-direction: row;

        ${Label} {
          margin-right: 10px;
          min-width: 190px;
        }

        ${OrLabel} {
          margin: 0 10px;
        }
    `}
`;

class LocationSearchBlock extends PureComponent {
  render() {
    const {
      geolocationEnabled,
      searchingGeolocation,
      name,
      searchLocationPending,
      pendingProductsRequest,
      onGeolocationButtonClick,
      currentActiveProductIds,
      currentActivePageUrlSuffix
    } = this.props;

    return (
      <Wrapper name={name}>
        <Label>{getTranslation('postcodeCheckerLabel')}</Label>
        <LocationSearchInputBlock
          disabled={searchLocationPending || searchingGeolocation}
          searchLocationPending={searchLocationPending || searchingGeolocation}
          pendingProductsRequest={pendingProductsRequest}
          name={name}
        />
        {geolocationEnabled && (
          <>
            <OrLabel>{getTranslation('geolocationOrLabel')}</OrLabel>
            <GeolocationButtonWrapper>
              <GeolocationButton
                label={getTranslation('geolocationButtonLabel')}
                disabled={searchLocationPending || searchingGeolocation || pendingProductsRequest}
                onClick={() => {
                  onGeolocationButtonClick(currentActiveProductIds, currentActivePageUrlSuffix);
                }}
              />
            </GeolocationButtonWrapper>
          </>
        )}
      </Wrapper>
    );
  }
}

LocationSearchBlock.propTypes = {
  // DON'T CHANGE THE VALUES of the following prop, the format is due to analytics
  name: PropTypes.oneOf(['above product listing', 'filter block']).isRequired,
  geolocationEnabled: PropTypes.bool.isRequired,
  searchingGeolocation: PropTypes.bool.isRequired,
  searchLocationPending: PropTypes.bool.isRequired,
  pendingProductsRequest: PropTypes.bool.isRequired,
  onGeolocationButtonClick: PropTypes.func.isRequired,
  currentActiveProductIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentActivePageUrlSuffix: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    geolocationEnabled: state.listingPage.locationSearchSetup.geolocationEnabled,
    searchingGeolocation: state.listingPage.locationSearchSetup.searchingGeolocation,
    searchLocationPending:
      getActiveListingPage(state).productsDeliveriesSearch.searchPending ||
      state.listingPage.locationSearchSetup.resolvingLocation,
    pendingProductsRequest: state.listingPage.commonData.xhrStatus.pendingProductsRequest,
    currentActiveProductIds: getActiveListingPage(state).productList.map((product) => product.id),
    currentActivePageUrlSuffix: getActiveListingPage(state).pageUrlSuffix
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onGeolocationButtonClick: (currentActiveProductIds, currentActivePageUrlSuffix) => {
      dispatch(searchDeliveriesForGeoLocation(currentActiveProductIds, currentActivePageUrlSuffix));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearchBlock);
